// Request schemas of the Steuerberater export (spec §1.13). In src/shared so the React client validates
// the month picker with the same object; the German messages here are what the user reads on the form.
import { z } from 'zod'

export const monatsExportSchema = z.object({
  jahr: z.number().int().min(2000, 'Jahr unplausibel.').max(2100, 'Jahr unplausibel.'),
  monat: z.number().int().min(1, 'Monat zwischen 1 und 12.').max(12, 'Monat zwischen 1 und 12.'),
})
export type MonatsExport = z.infer<typeof monatsExportSchema>

export const exporteQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).optional(),
})
export type ExporteQuery = z.infer<typeof exporteQuerySchema>

export const EXPORTE_DEFAULT_LIMIT = 50
